<template>
  <v-flex xs12>
    <v-data-table
      :headers="headers"
      :rows-per-page-items="[25, 50, 100]"
      rows-per-page-text="Registros por página"
      :items="payments"
      :loading="working.wPayments"
      :pagination.sync="pagination"
      :total-items="totalItemsFromBackend"
      item-key="id"
      no-results-text="No se encontraron coincidencias"
      :no-data-text="permits['WATCH_PAYMENTS'] ? (working.wPayments ? 'Cargando' : (payments.length > 0 ? '' : 'No hay pagos')) : 'No tienes permiso de ver pagos'"
    >
      <template v-slot:headers>
        <tr>
          <th
            class="text-xs-left"
            style="width: 380px; max-width: 380px; min-width: 380px;"
          >Nombre del pago</th>
          <th
            class="text-xs-left"
            style="width: 280px; max-width: 280px; min-width: 280px;"
          >Concepto</th>
          <th class="text-xs-right" style="width: 120px; max-width: 120px; min-width: 120px;">Monto</th>
          <th
            class="text-xs-left"
            style="width: 170px; max-width: 170px; min-width: 170px;"
          >Fecha de emisión</th>
          <th class="text-xs-left" style="width: 160px; max-width: 160px; min-width: 160px;">Estatus</th>
          <th style="width: 160px; max-width: 160px; min-width: 160px;">&nbsp;</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td
          class="text-xs-left"
          style="width: 380px; max-width: 380px; min-width: 380px;"
        >
         {{ props.item.name }} 
        </td>
        <td
          class="text-xs-left"
          style="width: 280px; max-width: 280px; min-width: 280px;"
        >
        {{ props.item.concept.name }}</td>
        <td
          class="text-xs-right"
          style="width: 120px; max-width: 120px; min-width: 120px;"
        >{{ props.item.concept.amount | formatCurrency }}</td>
        <td
          class="text-xs-left"
          style="width: 170px; max-width: 170px; min-width: 170px;"
        >{{ props.item.createdAt | formatDateShort }}</td>
        <td class="text-xs-left" style="width: 160px; max-width: 160px; min-width: 160px;">
          <v-layout row>
            <v-flex>
              <v-img :src="getIcon(props.item.status)" width="16px"></v-img>
            </v-flex>
            <v-flex>{{ props.item.status | paymentStatus }}</v-flex>
          </v-layout>
        </td>
        <td style="width: 160px; max-width: 160px; min-width: 160px;">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" v-on="on"
                @click="editPayment(props.item)"
                icon
                :disabled="!permits['UPDATE_PAYMENTS']"
                v-if="props.item.status === 'DRAFT'"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </template>  
            <span>Publicar Pago</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" v-on="on"
                @click="viewPayment(props.item)"
                icon
                :title="'Pago con ID ' + props.item.id"
                :disabled="!permits['WATCH_PAYMENTS']"
                v-if="props.item.status !== 'DRAFT'"
              >
                <v-icon>visibility</v-icon>
              </v-btn>
            </template>
            <span>Ver Pago</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" v-on="on"
                @click="deletePayment(props.item)"
                icon
                :disabled="!permits['UPDATE_PAYMENTS'] || props.item.status !== 'DRAFT'"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar Pago</span>
          </v-tooltip>
        </td>
      </template>
      <template
        v-slot:pageText="props"
      >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
    </v-data-table>

    <CreatePayment
      :title="modals.title"
      v-model="modals.createPayment"
      :payment="payment"
      @created="onNewPayment"
      @onUpdated="onUpdatedPayment"
      @onClosed="onCancel"
    />

    <PaymentEditModal
      v-model="modals.payment"
      :payment="payment"
      @onClosed="onCancel"
      @onUpdated="onUpdatedPayment"
    />
    <PaymentsStudents
      v-model="modals.paymentDetail"
      :paymentData="payment"
      @onClosed="onCancel"
    />
    <desition
      @desition="($event) ? onDeletePayment(): ''"
      v-model="modals.confirmDelete"
      title="Eliminar pago"
      description="¿Está seguro que desea realizar dicha acción, este proceso es irreversible y no podrá recuperar la información?"
    ></desition>
    <loading v-model="working.wLoading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </v-flex>
</template>
<script>
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import desition from "../../Dialogs/Confirm";
import { funciones } from "../../../Mixins/Funciones";
import PaymentEditModal from "../../Modals/PaymentEditModal";
import CreatePayment from "../../Modals/CreatePayment";
import PaymentsStudents from "../../Routes/Nested_Routes/PaymentsStudents"

export default {
  components: {
    PaymentEditModal,
    loading,
    success,
    error,
    desition,
    CreatePayment,
    PaymentsStudents
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    showAddForm: {
      type: Boolean,
      required: true,
      default: false,
    },
    search: {
      type: String,
      required: true,
      default: "",
    },
  },
  mixins: [funciones],
  data: () => ({
    pagination: {
    },
    filters: {
      search: "",
    },
    working: {
      wPayments: false,
      wLoading: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    payments: [],
    totalItemsFromBackend: 0,
    roles: [],
    headers: [
      {
        text: "Nombre del pago",
        align: "left",
        value: "name",
        filterItems: [],
      },
      {
        text: "Concepto",
        value: "concept.name",
        align: "left",
        filterItems: [],
      },
      {
        text: "Monto",
        value: "concept.amount",
        filterItems: [],
        align: "right",
      },
      {
        text: "Fecha de emisión",
        value: "createdAt",
        filterItems: [],
        align: "left",
      },
      {
        text: "Estatus",
        value: "status",
        filterItems: [],
        align: "left",
      },
      {
        text: "",
        value: "id",
        filterItems: [],
        align: "center",
      },
    ],
    tab: null,
    payment: null,
    modals: {
      title: "",
      payment: false,
      createPayment: false,
      import: false,
      confirmDelete: false,
      paymentDetail: false,
    },
    permits: [],
  }),
  watch: {
    showAddForm() {
      if (this.showAddForm) {
        this.addPayment();
      }
    },
    user() {
      if (this.user.id) this.mapPermits();
      if (this.permits["WATCH_PAYMENTS"] && !this.payments.length > 0) {
        this.getPayments();
      }
    },
    search() {
      if (!this.working.wPayments) {
        this.filters.search = this.search;
        this.getPayments();
      }
    },
    pagination: {
      handler() {
        if (this.permits["WATCH_PAYMENTS"]) {
          this.getPayments();
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.user.id) this.mapPermits();
    if (this.permits["WATCH_PAYMENTS"] && !this.payments.length > 0) {
      this.getPayments();
    }
  },
  filters: {
    paymentStatus: function (value) {
      switch (value) {
        case "DRAFT":
          return "Borrador";
        case "READY":
          return "Procesando";
        case "ENABLED":
          return "Publicado";
        default:
          return "Inactivo";
      }
    },
  },
  methods: {
    mapPermits() {
      var usr = this.user;
      var wbRol = usr.webRole;
      var catalogs = wbRol.catalogs;
      for (var c in catalogs) {
        if (catalogs[c].name.includes("PAYMENTS")) {
          this.permits[catalogs[c].name] = 1;
        }
      }
      this.loading = this.permits["WATCH_PAYMENTS"] ? true : false;
    },
    addPayment() {
      this.payment = null;
      this.modals.title = "Emitir pago";
      this.modals.createPayment = true;
    },
    onNewPayment(event) {
      event.new = true;
      this.modals.createPayment = false;
      this.getPayments(true);
      this.$emit("closedPopup");
    },
    onUpdatedPayment(event) {
      if (event.success) {
        this.toast.success = true;
        var local = this.payments.find((el) => el.id === event.payment.id);
        if (local) {
          local.name = event.payment.name;
          local.dueDate = event.payment.dueDate;
          local.metadata = event.payment.metadata;
          local.status = event.payment.status;
        }

        this.onCancel();
      } else {
        this.toast.failed = true;
      }
    },
    editPayment(payment) {
      this.payment = payment;
      this.modals.payment = true;
    },
    viewPayment(payment) {
      this.payment = payment;
      this.modals.paymentDetail = true;
      /*this.$router.push({
        path: "/es/panel/payments/" + payment.id,
      });*/
    },
    getPayments(forceUpdate) {
      var offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      this.working.wPayments = true;
      this.$store
        .dispatch("payments/getPayments", { 
          search: this.filters.search, 
          page_size: this.pagination.rowsPerPage, 
          offset: offset 
        })
        .then((response) => {
          this.working.wPayments = false;
          this.payments = response.data.items;
          this.totalItemsFromBackend = response.data.total;
          if (forceUpdate) {
            this.$forceUpdate();
          }
        })
        .catch(() => {
          this.working.wPayments = false;
        });
    },
    onCancel() {
      this.payment = null;
      this.modals.payment = false;
      this.modals.createPayment = false;
      this.modals.confirmDelete = false;
      this.$forceUpdate();
      this.$emit("closedPopup");
    },
    deletePayment(payment) {
      this.payment = payment;
      this.modals.confirmDelete = true;
    },
    onDeletePayment() {
      this.working.wLoading = true;
      this.$store
        .dispatch("payments/deletePayment", this.payment.id)
        .then(() => {
          this.working.wLoading = false;
          this.toast.success = true;
          this.getPayments(true);
        })
        .catch(() => {
          this.toast.failed = true;
          this.working.wLoading = false;
        });
    },
    getIcon(status) {
      switch (status) {
        case "DRAFT":
          return require("@/assets/payments/payment_status_draft.png");
        case "READY":
          return require("@/assets/payments/payment_status_enabled.png");
        case "ENABLED":
          return require("@/assets/payments/payment_status_enabled.png");
        default:
          return require("@/assets/payments/payment_status_draft.png");
      }
    },
  },
};
</script>

<style>
</style>